export default function () {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
            <rect x="4.66675" y="8.33337" width="11.6667" height="8.33333" rx="0.833333" stroke="white" strokeWidth="1.25" />
            <path
                d="M7.16675 8.33333V5.74074C7.16675 3.95093 8.65915 2.5 10.5001 2.5C12.341 2.5 13.8334 3.95093 13.8334 5.74074V8.33333"
                stroke="white"
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M10.5 12.5V14.1667" stroke="white" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M11.75 11.25C11.75 11.9404 11.1904 12.5 10.5 12.5C9.80964 12.5 9.25 11.9404 9.25 11.25C9.25 10.5596 9.80964 10 10.5 10C11.1904 10 11.75 10.5596 11.75 11.25Z"
                fill="white"
            />
        </svg>
    );
}
